/**
 * Rapor aksiyonlarının açtığı görüntüleyici penceresi.
 *
 * `useReportActions` bir `ReportOpenRequest` üretir (rapor işlemi kimliği ya da doğrudan
 * rapor kimliği + filtre JSON'u); burada o istek `/DXXRDV` görüntüleyicisinin beklediği
 * `reportUrl`'e çevrilir. Rapor işlemi olmayan istekler de çalışır: DAL'ın rapor kaynağı
 * kimliği önce işlem, bulamazsa rapor olarak arar.
 */
import { useTranslation } from 'react-i18next';
import { Dialog } from '@/shared/ui/Dialog';
import type { ReportOpenRequest } from '@/features/actions/model/types';
import { buildReportUrl } from '../model/reportUrl';
import { ReportViewer } from './ReportViewer';

export interface ReportDialogProps {
  request: ReportOpenRequest | null;
  onClose: () => void;
  /** Rapor işlemindeki ReportZoom (-1 tüm sayfa, -2 sayfa genişliği, pozitif çarpan). */
  zoom?: number | null;
}

export function ReportDialog({ request, onClose, zoom }: ReportDialogProps) {
  const { t } = useTranslation();
  const id = request?.reportActionId || request?.reportId || '';
  const reportUrl = id ? buildReportUrl(id, request?.filterValue) : '';

  return (
    <Dialog
      open={!!request}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={request?.reportName || t('report.title')}
      size="full"
    >
      <div className="h-[80dvh] min-h-0 w-full">
        {reportUrl ? <ReportViewer reportUrl={reportUrl} zoom={zoom} /> : null}
      </div>
    </Dialog>
  );
}
